export default __webpack_public_path__ + "apply11d8785f.png";